import React, { useState, useEffect } from 'react';
import { GridView, SimpleView } from '@digital/ui';
import { Collapse } from 'antd';
import {
  TipoPacote,
  getAllDisciplinas,
  getAllTipos,
  createDisciplina,
  createTipo,
  updateDisciplina,
  updateTipo,
  deleteDisciplina,
  deleteTipo,
} from '@app/api/tipoPacote';
import {
  AcronimoPacote,
  getAllAcronimosPacote,
  createAcronimoPacote,
  updateAcronimoPacote,
  deleteAcronimoPacote,
} from '@app/api/acronimosPacote';
import * as Yup from 'yup';
import TipoPacoteComponent from './TipoPacote';
import AcronimoPacoteTableComponent from './AcronimoPacoteTable';

const { Panel } = Collapse;

const validationSchema = Yup.object().shape({
  sigla: Yup.string().required('Sigla deve ser informada'),
  disciplinaId: Yup.string().required('Disciplina deve ser informada'),
  tipoId: Yup.string().required('Tipo deve ser informado'),
});

const AcronimoPacotePacoteComponent = () => {
  const [acronimos, setAcronimos] = useState<AcronimoPacote[]>();
  const [disciplinas, setDisciplinas] = useState<TipoPacote[]>();
  const [tipos, setTipos] = useState<TipoPacote[]>();
  const [shouldUpdate, setShouldUpdate] = useState<boolean>(false);

  const fetchData = () => {
    const getDisciplinas = async () => {
      const result = await getAllDisciplinas();
      if (result) setDisciplinas(result);
    };

    const getTipos = async () => {
      const result = await getAllTipos();
      if (result) setTipos(result);
    };

    const getAcronimosPacote = async () => {
      const result = await getAllAcronimosPacote();
      if (result) setAcronimos(result);
    };

    getDisciplinas();
    getTipos();
    getAcronimosPacote();
  };

  useEffect(() => fetchData(), []);
  useEffect(() => fetchData(), [shouldUpdate]);

  const onCreate = (acronimo: AcronimoPacote) => {
    const pacote: AcronimoPacote = {
      id: '',
      sigla: acronimo.sigla,
      disciplinaId: acronimo.disciplinaId,
      tipoId: acronimo.tipoId,
    };
    return createAcronimoPacote(pacote).then(resp => {
      if (resp.valid) fetchData();
      return resp;
    });
  };

  return (
    <SimpleView>
      <GridView noform>
        {true && (
          <>
            <AcronimoPacoteTableComponent
              titulo="Acrônimos"
              data={acronimos || []}
              disciplinas={(disciplinas && disciplinas.map(a => ({ text: a.data.nome, value: a.id.toString() }))) || []}
              tipos={(tipos && tipos.map(a => ({ text: a.data.nome, value: a.id.toString() }))) || []}
              handleCreate={createAcronimoPacote}
              handleUpdate={updateAcronimoPacote}
              handleDelete={deleteAcronimoPacote}
              shouldUpdate={setShouldUpdate}
              isUpdate={shouldUpdate}
            />

            <TipoPacoteComponent
              titulo="Disciplina"
              label="Nome da Disciplina"
              data={disciplinas || []}
              handleCreate={createDisciplina}
              handleUpdate={updateDisciplina}
              handleDelete={deleteDisciplina}
              shouldUpdate={setShouldUpdate}
              isUpdate={shouldUpdate}
            />

            <TipoPacoteComponent
              titulo="Tipo"
              label="Nome do Tipo"
              data={tipos || []}
              handleCreate={createTipo}
              handleUpdate={updateTipo}
              handleDelete={deleteTipo}
              shouldUpdate={setShouldUpdate}
              isUpdate={shouldUpdate}
            />
          </>
        )}
      </GridView>
    </SimpleView>
  );
};

export default AcronimoPacotePacoteComponent;
